import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';

@JsonObject('model.QBClass')
export class QBClass extends AbstractModel {

    @JsonProperty(String, 'id')
    id: string;

    @JsonProperty(String, 'name')
    name?: string;

    @JsonProperty(String, 'fullyQualifiedName')
    fullyQualifiedName?: string;
}
